import { render, staticRenderFns } from "./Doelgroep.vue?vue&type=template&id=ba0b2cf0&scoped=true"
import script from "./Doelgroep.vue?vue&type=script&lang=ts"
export * from "./Doelgroep.vue?vue&type=script&lang=ts"
import style0 from "./Doelgroep.vue?vue&type=style&index=0&id=ba0b2cf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0b2cf0",
  null
  
)

export default component.exports